import React from 'react';

// ---------------------------------------------------------------------
// Card primitives — single source of truth for the dashboard look.
// Two variants: StatCard (icon + title + big number) and PanelCard
// (icon + title + arbitrary body). Both share the same surface chrome.
// ---------------------------------------------------------------------

export function StatCard({ icon, title, value, subtitle, subtitleTone, subtitleTruncate, onClick, muted }) {
    const clickable = typeof onClick === 'function';
    const subtitleColor =
        subtitleTone === 'success' ? 'text-green-400'
            : subtitleTone === 'danger' ? 'text-red-300'
            : 'text-gray-500';

    return (
        <div
            onClick={onClick}
            className={`card-chrome ${clickable ? 'card-chrome-hover' : ''}`}
        >
            <div className="flex items-center gap-3">
                {/* Brand-tinted icon badge — single accent across the page. */}
                <div className={
                    muted
                        ? 'w-9 h-9 rounded-lg flex items-center justify-center bg-white/[0.04] text-gray-500'
                        : 'brand-icon-badge'
                }>
                    {icon}
                </div>
                <h3 className="text-sm font-medium text-gray-300 leading-tight min-w-0 break-words">{title}</h3>
            </div>

            <p className={`mt-3 sm:mt-4 text-2xl sm:text-3xl font-bold ${muted ? 'text-gray-500' : 'text-white'} truncate`}>
                {value}
            </p>
            <p className={`mt-1 text-[13px] sm:text-xs ${subtitleColor} ${subtitleTruncate ? 'truncate' : ''}`}>
                {subtitle}
            </p>
        </div>
    );
}

export function PanelCard({ icon, title, children }) {
    return (
        <section className="card-chrome">
            <header className="flex items-center gap-3 mb-4">
                <div className="brand-icon-badge">{icon}</div>
                <h3 className="text-sm font-semibold text-white">{title}</h3>
            </header>
            {children}
        </section>
    );
}